import lists from './lists'

const archive = {
    namespaced: true,
    state: {
    },
    mutations: {
    },
    getters: {
    },
    modules: {
        lists
    }
}

export default archive;